import React from "react";
import "./acordion.scss";
import "../../../styles/fontSizes.scss";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
/* Ejemplo de data:
  data = {
        title: "El estudiante debe realizar la solicitud siguiendo los siguientes pasos",
        mdDescription: "# CANCELACIÓN DE PERIODO ACADÉMICO\n\n¿Qué es cancelación de periodo académico?\n\nEs el procedimiento a través del cual un estudiante podrá cancelar su periodo académico, es decir, la totalidad de asignaturas o actividades inscritas. Esta cancelación se da en casos de fuerza mayor, cao fortuito debidamente documentado o por traslado entre programas de la Universidad. El único requisito para realizar la solicitud es estar matriculado en el periodo en cuestión.  \n\n##### La cancelación de período académico se puede realizar siguiendo los siguientes pasos:\n\n1. Ingresar al SIA a través de la página web https://dninfoa.unal.edu.co/\n2. Ingresar al Portal académico con usuario y contraseña\n3. Solicitudes\n4. Entregar los documentos soportes en la respectiva Dirección de Programa Curricular\n\n\nDe igual forma, tenga en cuenta las fechas establecidas en el Calendario de solicitudes estudiantiles:\n[http://delapaz.unal.edu.co/index.php?id=24](link)\n"
    } 
 */
const Acordion = ({ id, data }) => {
  return (
    <div className="acordion__container">
      <input type="checkbox" id={`checkbox-${id}`} />
      <label className="acordion__label" htmlFor={`checkbox-${id}`}>
        {data.title}
      </label>
      <div className="acordion__content">
        <ReactMarkdown>{data.mdDescription}</ReactMarkdown>
      </div>
    </div>
  );
};

export default Acordion;
